import { SkeletonCircleComponent, SkeletonLinesComponent } from "@iventis/components";
import { styled } from "@iventis/styles";
import React from "react";
import { StyledCommentHeader, StyledCommentWrapperWithPadding, StyledFooter, StyledTextContainer } from "./comment";

export const SkeletonComment = () => (
    <StyledCommentWrapperWithPadding>
        <StyledCommentHeader className="comment-header">
            <SkeletonUser>
                <SkeletonCircleComponent width="40px" />
                <SkeletonLinesComponent width="150px" height="15px" />
            </SkeletonUser>
        </StyledCommentHeader>
        <StyledTextContainer className="comment-body" isInCommentList={false}>
            <SkeltonContent>
                <SkeletonLinesComponent width="350px" height="15px" />
            </SkeltonContent>
        </StyledTextContainer>
        <StyledFooter className="comment-footer">
            <SkeletonLinesComponent width="100px" height="15px" />
        </StyledFooter>
    </StyledCommentWrapperWithPadding>
);

const SkeltonContent = styled.div`
    width: 350px;
`;

export const SkeletonUser = styled.div`
    display: flex;
    font-weight: 500;
    place-items: center;
    gap: 10px;
    padding: 10px 0;
`;
